import { render, staticRenderFns } from "./QuoteBuilderSubletItem.vue?vue&type=template&id=4bbbc928"
import script from "./QuoteBuilderSubletItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderSubletItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderSubletItem.vue?vue&type=style&index=0&id=4bbbc928&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbbc928')) {
      api.createRecord('4bbbc928', component.options)
    } else {
      api.reload('4bbbc928', component.options)
    }
    module.hot.accept("./QuoteBuilderSubletItem.vue?vue&type=template&id=4bbbc928", function () {
      api.rerender('4bbbc928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderSublets/QuoteBuilderSubletItem.vue"
export default component.exports